import { VkVerifyPage } from '@/app/pages/auth/vk/vk-verify-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/vk-verify')({
  component: VkVerifyPage,
});
